import React from 'react';
import PropTypes from 'prop-types';
import {
  Tabs, Tab, TabList, TabPanel
} from 'react-tabs';
import { CustomProvider } from 'react/utils/renderUtils';

import StopDetailsPopup from 'react/components/RouteDetails/StopDetailsPopup';
import ResequenceHistory from 'react/components/RouteDetails/ResequenceHistory';

class StopDetails extends React.PureComponent {
  constructor() {
    super();
    this.state = { tabIndex: null };
  }

  render() {
    const {
      index,
      routeId,
      stopId,
      marker,
      map,
      hasGeocodeCreatePermission,
      hasGeocodeListPermission,
      hasEditLocationPermission
    } = this.props;

    const resequenceTitle = Monet.I18n.getResourcesByKey('resequenceHistory.title');
    const stopDetailsTitle = Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.title');

    const hideTab = index !== 0 ? 'hide' : '';
    const { tabIndex } = this.state;
    const { hasPRO } = Monet.Session.RouteDetail.screensList[routeId];

    return (
      <CustomProvider>
        <Tabs
          selectedIndex={tabIndex || index}
          onSelect={(selectedIndex) => this.setState({ tabIndex: selectedIndex })}
          data-testid="stopDetailsModalTabs"
        >
          <TabList>
            <Tab>
              <div data-testid="stopDetailsTab" className={`panel ${hideTab}`}>
                <div className="title">{stopDetailsTitle}</div>
              </div>
            </Tab>

            {hasPRO ? (
              <Tab>
                <div data-testid="resequenceTab" className="panel">
                  <div className="title">{resequenceTitle}</div>
                </div>
              </Tab>
            ) : null}
          </TabList>

          <TabPanel>
            {index !== 0 ? null
              : (
                <StopDetailsPopup
                  stopId={String(stopId)}
                  routeId={String(routeId)}
                  marker={marker}
                  map={map}
                  hasGeocodeCreatePermission={hasGeocodeCreatePermission}
                  hasGeocodeListPermission={hasGeocodeListPermission}
                  hasEditLocationPermission={hasEditLocationPermission}
                />
              )}
          </TabPanel>

          {hasPRO ? (
            <TabPanel>
              <ResequenceHistory
                routeId={routeId}
              />
            </TabPanel>
          ) : null}

        </Tabs>
      </CustomProvider>
    );
  }
}

StopDetails.propTypes = {
  index: PropTypes.number.isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  map: PropTypes.object.isRequired,
  marker: PropTypes.object.isRequired,
  hasGeocodeCreatePermission: PropTypes.bool.isRequired,
  hasGeocodeListPermission: PropTypes.bool.isRequired,
  hasEditLocationPermission: PropTypes.bool.isRequired
};

export default StopDetails;
